import FilterOptions from "../../../components/filter-options/filter-options";
import Page from "../../page";

const FilterOptionsPage = () => {
  return (
    <Page>
      <FilterOptions />
    </Page>
  );
};

export default FilterOptionsPage;
